import { useEffect } from 'react';
import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { CandleChartPopout } from '../components/candle-chart/CandleChartWidget';

/** One Candle Chart in its own window, with its own saved settings. */
export function CandleChartPopoutPage(): ReactElement {
  const { windowId = '' } = useParams<{ windowId: string }>();

  useEffect(() => {
    document.title = 'Candle Chart';
  }, []);

  return (
    <div className="h-screen w-screen bg-dark-bg flex flex-col">
      <CandleChartPopout popoutId={windowId} />
    </div>
  );
}
